import { messengerService } from "srcReact/services"
import { shareMediaConstants as smc } from "./constants"

export const shareMediaActions = {
    searchConversationsToShare,
    getConversationsToShare,
    sendMedia
}

const defaultQuantity = 20
function getConversationsToShare(organizationId, search, pagination, quantity = defaultQuantity) {
    const { nextOffset, isPagination } = pagination
    return (dispatch) => {
        dispatch(request(isPagination))

        messengerService.getConversations(organizationId, '', nextOffset, quantity).then(
            (response) => {
                dispatch(success(response))
            },
            (error) => {
                dispatch(failure(error))
            }
        )
    }

    function request(isPagination) {
        return { type: smc.GET_CONVS_TO_SHARE_REQUEST, isPagination }
    }
    function success(response) {
        const updatedResponse = { ...response, isPagination, search }
        return { type: smc.GET_CONVS_TO_SHARE_SUCCESS, updatedResponse }
    }
    function failure(error) {
        return { type: smc.GET_CONVS_TO_SHARE_FAILURE, error }
    }
}

function searchConversationsToShare(organizationId, search, pagination, type, quantity = defaultQuantity) {
    const { nextOffset, isPagination } = pagination
    return (dispatch) => {
        dispatch(request(isPagination))

        messengerService.searchConversations(organizationId, search, nextOffset, quantity, type).then(
            (response) => {
                dispatch(success(response))
            },
            (error) => {
                dispatch(failure(error))
            }
        )
    }

    function request(isPagination) {
        return { type: smc.SEARCH_CONVS_TO_SHARE_REQUEST, isPagination }
    }
    function success(response) {
        const updatedResponse = { ...response, isPagination, search }
        return { type: smc.SEARCH_CONVS_TO_SHARE_SUCCESS, updatedResponse }
    }
    function failure(error) {
        return { type: smc.SEARCH_CONVS_TO_SHARE_FAILURE, error }
    }
}

function sendMedia(conversations, fileId) {
    return (dispatch) => {
        for (let i = 0; i < conversations.length; i++) {
            dispatch(request(fileId))

            messengerService.postMessage(conversations[i].conversation.id, null, null, fileId).then(
                (response) => {
                    const isLastConversation = conversations.length - 1 === i
                    dispatch(success(response, isLastConversation))
                },
                (error) => {
                    dispatch(failure(error))
                }
            )
        }
    }

    function request(fileId) {
        return { type: smc.SEND_MEDIA_FILE_REQUEST, fileId }
    }
    function success(response, isLastConversation) {
        const updatedResponse = { ...response, isLastConversation }
        return { type: smc.SEND_MEDIA_FILE_SUCCESS, updatedResponse }
    }
    function failure(error) {
        return { type: smc.SEND_MEDIA_FILE_FAILURE, error }
    }
}

